// === CONTEXTE BUG REPORT ===
// Collecte des données techniques attachées au rapport : screenshot du canvas,
// snapshot des sauvegardes localStorage, et logs récents.

import { LogCapture } from './LogCapture';

const SAVE_KEY_PREFIX = 'deadtide_';
/** Clés bruyantes/inutiles pour le repro — on les exclut du snapshot. */
const SAVE_KEY_EXCLUDE = new Set([
  'deadtide_bug_reports',     // pas besoin de joindre l'historique des bugs
  'deadtide_bug_last_sent',   // timestamp anti-spam
]);

/** Capture le canvas Phaser en PNG. Retourne null si la capture échoue. */
export async function captureCanvas(canvas: HTMLCanvasElement): Promise<Blob | null> {
  return new Promise((resolve) => {
    try {
      canvas.toBlob((blob) => resolve(blob), 'image/png');
    } catch {
      resolve(null);
    }
  });
}

/** Snapshot JSON de toutes les clés `deadtide_*` (hors clés exclues). */
export function buildSaveSnapshot(): Blob {
  const snapshot: Record<string, unknown> = {
    capturedAt: new Date().toISOString(),
    keys: {},
  };
  const keys: Record<string, unknown> = {};
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key || !key.startsWith(SAVE_KEY_PREFIX) || SAVE_KEY_EXCLUDE.has(key)) continue;
      const raw = localStorage.getItem(key);
      if (raw === null) continue;
      // Tente de parser en JSON pour un rendu propre, sinon garde la string brute
      try { keys[key] = JSON.parse(raw); }
      catch { keys[key] = raw; }
    }
  } catch {
    // localStorage indisponible (mode privé Safari, etc.)
  }
  snapshot.keys = keys;
  const json = JSON.stringify(snapshot, null, 2);
  return new Blob([json], { type: 'application/json' });
}

/** Logs récents en plain-text. */
export function buildLogsBlob(): Blob {
  return new Blob([LogCapture.formatText()], { type: 'text/plain' });
}
